import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ZoomOut.svg",
  "use": "ZoomOut.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"ZoomOut.svg\"><path d=\"M48.9878,54.5255,40.31,44.27a19.0519,19.0519,0,1,1,3.9481-3.9476l10.2569,8.6758a3.9206,3.9206,0,1,1-5.5273,5.5273ZM29.01,14.0208a15,15,0,1,0,15,15A15,15,0,0,0,29.01,14.0208Zm-8,17a2,2,0,0,1,0-4h16a2,2,0,0,1,0,4Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol